import { useState } from "react";
import type { QuickBetslipBet } from "../../store/state/sportsbook-betting/sportsbook-betting-selectors";

type QuickBetslipPresentation = {
  combinationId: string | null;
  shouldShowQuickBetslip: boolean;
};

export function useQuickBetslipPresentation(
  quickBetslipBet: QuickBetslipBet | null,
  isReceipt: boolean,
): QuickBetslipPresentation {
  const [lastValidCombinationId, setLastValidCombinationId] = useState<string | null>(() =>
    quickBetslipBet?.status === "valid" ? quickBetslipBet.combinationId : null,
  );
  const [previousQuickBetslipBet, setPreviousQuickBetslipBet] = useState(quickBetslipBet);
  const [previousIsReceipt, setPreviousIsReceipt] = useState(isReceipt);

  if (quickBetslipBet !== previousQuickBetslipBet || isReceipt !== previousIsReceipt) {
    setPreviousQuickBetslipBet(quickBetslipBet);
    setPreviousIsReceipt(isReceipt);

    if (isReceipt) {
      setLastValidCombinationId(null);
    } else if (quickBetslipBet?.status === "valid") {
      setLastValidCombinationId(quickBetslipBet.combinationId);
    } else if (quickBetslipBet?.status === "fallback") {
      setLastValidCombinationId(null);
    }
  }

  const combinationId = isReceipt
    ? null
    : quickBetslipBet?.status === "valid"
    ? quickBetslipBet.combinationId
    : lastValidCombinationId;

  // Keep the mounted QBS instance across transient picker gaps (pending / brief null)
  // so enter animations do not replay when going from 1 → 2 selections.
  const shouldShowQuickBetslip =
    combinationId != null &&
    (quickBetslipBet == null || quickBetslipBet.status === "valid" || quickBetslipBet.status === "pending");

  return {
    combinationId,
    shouldShowQuickBetslip,
  };
}
